module.exports = __webpack_public_path__ + "images/slow-default.94e4344263ddcffd8bd06265d9600cc4.png";